import { createFileRoute, redirect } from '@tanstack/react-router'
import type { SpendFilters, SpendStatus, SpendType } from '@/features/accounting-spend/api'
import { hasGrant } from '@/lib/me'

export const Route = createFileRoute('/_authenticated/accounting/spend/')({
  validateSearch: (search: Record<string, unknown>): SpendFilters => ({
    type: isSpendType(search.type) ? search.type : undefined,
    status: isSpendStatus(search.status) ? search.status : undefined,
    print_later: search.print_later === true || search.print_later === '1' ? true : undefined,
    from: typeof search.from === 'string' ? search.from : undefined,
    to: typeof search.to === 'string' ? search.to : undefined,
    payee: typeof search.payee === 'string' ? search.payee : undefined,
    payment_account:
      typeof search.payment_account === 'string' ? search.payment_account : undefined,
    search: typeof search.search === 'string' ? search.search : undefined,
  }),
  beforeLoad: ({ context, search }) => {
    if (!hasGrant(context.queryClient, 'accounting_money_document.view')) {
      throw redirect({ to: '/accounting' })
    }
    throw redirect({ to: '/accounting/expenses', search })
  },
  component: () => null,
})

const isSpendType = (value: unknown): value is SpendType =>
  typeof value === 'string' && ['expense', 'card_credit'].includes(value)
const isSpendStatus = (value: unknown): value is SpendStatus =>
  typeof value === 'string' && ['draft', 'posted', 'void'].includes(value)
